(() => {
  const init = root => {
    root.querySelectorAll('[data-world-fold]').forEach(fold => {
      if (fold.dataset.ready) return;
      fold.dataset.ready = 'true';

      const section = fold.closest('.sv-collections');
      const wrapper = fold.closest('.page-wrapper');
      const desktop = matchMedia('(min-width: 750px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const destinations = [...fold.querySelectorAll('.ss-fold__destination')];
      const controller = new AbortController();
      let frame = 0;
      let visible = true;

      const clamp = value => Math.max(0, Math.min(1, value));
      const range = (value, start, end) => clamp((value - start) / (end - start));
      const easeOut = value => 1 - Math.pow(1 - clamp(value), 3);

      const renderFinalState = () => {
        section.style.setProperty("--fold-gate-phase", '0');
        section.style.setProperty("--fold-gate-y", '0px');
        section.style.setProperty("--fold-gate-scale", '1');
        fold.style.setProperty("--fold-art-opacity", '1');
        fold.style.setProperty("--fold-art-y", '0px');
        fold.style.setProperty("--fold-art-scale", '1');
        fold.style.setProperty("--fold-title-opacity", '1');
        fold.style.setProperty("--fold-title-y", '0px');
        fold.style.setProperty("--fold-title-scale", '1');
        fold.style.setProperty("--fold-anchor-opacity", '1');
        destinations.forEach(node => {
          node.style.setProperty('--fold-opacity', '1');
          node.style.setProperty('--fold-y', '0px');
        });
      };

      const update = () => {
        frame = 0;
        if (!desktop.matches) return;

        if (reduced.matches) {
          renderFinalState();
          return;
        }

        const nested = wrapper
          && getComputedStyle(wrapper).overflowY !== 'visible'
          && wrapper.scrollHeight > wrapper.clientHeight;
        const height = nested ? wrapper.clientHeight : innerHeight;
        const viewportTop = nested ? wrapper.getBoundingClientRect().top : 0;
        const top = fold.getBoundingClientRect().top - viewportTop;
        const holdDistance = Math.max(fold.offsetHeight - height, 1);
        const entryProgress = clamp((height - top) / height);
        const foldProgress = clamp(-top / holdDistance);

        const artProgress = easeOut(range(entryProgress, .08, .52));
        const gateMove = easeOut(range(foldProgress, .04, .34));
        const gatePhase = 1 - range(foldProgress, .06, .3);
        const titleEntryProgress = easeOut(range(entryProgress, .24, .64));
        const titleFinishProgress = easeOut(range(foldProgress, .06, .3));
        const titleProgress = titleEntryProgress * (.42 + titleFinishProgress * .58);
        const anchorProgress = easeOut(range(entryProgress, .26, .62));

        section.style.setProperty("--fold-gate-phase", gatePhase.toFixed(3));
        section.style.setProperty("--fold-gate-y", `${(Math.min(height * .1, 84) * gateMove).toFixed(2)}px`);
        section.style.setProperty("--fold-gate-scale", (1 - gateMove * .08).toFixed(3));
        fold.style.setProperty("--fold-art-opacity", (.18 + artProgress * .82).toFixed(3));
        fold.style.setProperty("--fold-art-y", `${((1 - artProgress) * 8).toFixed(2)}px`);
        fold.style.setProperty("--fold-art-scale", (.996 + artProgress * .004).toFixed(4));
        fold.style.setProperty("--fold-title-opacity", titleProgress.toFixed(3));
        fold.style.setProperty("--fold-title-y", `${((1 - titleProgress) * 8).toFixed(2)}px`);
        fold.style.setProperty("--fold-title-scale", (1 - (1 - titleProgress) * .006).toFixed(3));
        fold.style.setProperty("--fold-anchor-opacity", anchorProgress.toFixed(3));

        destinations.forEach((node, index) => {
          const destinationProgress = easeOut(range(
            entryProgress,
            .2 + index * .01,
            .5 + index * .012
          ));
          node.style.setProperty('--fold-opacity', (.12 + destinationProgress * .88).toFixed(3));
          node.style.setProperty('--fold-y', `${((1 - destinationProgress) * 8).toFixed(2)}px`);
        });
      };

      const schedule = () => {
        if (!frame && visible) frame = requestAnimationFrame(update);
      };

      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) schedule();
      });
      observer.observe(fold);

      const options = { passive: true, signal: controller.signal };
      window.addEventListener('scroll', schedule, options);
      wrapper?.addEventListener('scroll', schedule, options);
      window.addEventListener('resize', schedule, options);
      desktop.addEventListener('change', schedule, options);
      reduced.addEventListener('change', schedule, options);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(section)) return;
        controller.abort();
        observer.disconnect();
        cancelAnimationFrame(frame);
      }, { signal: controller.signal });

      update();
    });
  };

  init(document);
  if (!window.ssFoldEditorListener) {
    window.ssFoldEditorListener = true;
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
})();
